
import { defineComponent, ref, PropType, onMounted } from 'vue';
import { Material, TopicTree, MaterialTreeHistory } from '../../../types';
import { useRoute, useRouter } from 'vue-router';
import sanitizeHtml from 'sanitize-html';

type MaterialFind = {
  name: string;
  parent: string;
  next: string;
};
type MaterialPaths = {
  METHODOLOGY: MaterialFind;
  MATERIAL: MaterialFind;
};

const MATERIAL_PATHS: MaterialPaths = {
  METHODOLOGY: {
    name: 'methodology',
    parent: 'base_methodology',
    next: 'methodology_subject_id',
  },
  MATERIAL: {
    name: 'material',
    parent: 'base_material',
    next: 'material_subject_id',
  },
};

export default defineComponent({
  name: 'TopicItem',
  props: {
    topic: {
      type: Object as PropType<TopicTree>,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: String,
    },
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const studied = ref(false);
    const selectedMaterial = ref<Material>();
    const materials = ref<Material[]>();
    const expandedItem = ref(props.expanded);

    const openMaterialPreview = (material: MaterialTreeHistory) => {
      const routeName = route.name as string;
      void router.push({
        name: routeName.split('_').includes(MATERIAL_PATHS.METHODOLOGY.name)
          ? MATERIAL_PATHS.METHODOLOGY.next
          : MATERIAL_PATHS.MATERIAL.next,
        params: {
          subject: props.subject,
          id: material._id,
        },
      });
    };

    const sanitize = (html: string) => {
      return sanitizeHtml(html, {
        allowedTags: [],
      }).trim();
    };

    const totalStudied = () => {
      const studiedMaterials: MaterialTreeHistory[] =
        props.topic.materials.filter(
          (material) => material.history && material.history.studied
        );
      return studiedMaterials.length;
    };

    onMounted(() => {
      if (props.topic.materials.length) {
        findMaterialById();
      }
    });

    const findMaterialById = () => {
      const material = props.topic.materials.find(
        (material) => material._id === props.selected
      );
      expandedItem.value = !!material;
    };

    return {
      studied,
      selectedMaterial,
      materials,
      sanitize,
      totalStudied,
      expandedItem,
      openMaterialPreview,
    };
  },
});
